"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Badge = _interopRequireDefault(require("../badge/Badge"));

var _NavTabs = require("./NavTabs");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var _excluded = ["href", "active", "icon", "disabled", "notificationNumber", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcTab = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, _ref2) {
  var href = _ref.href,
      _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      icon = _ref.icon,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$notificationNumb = _ref.notificationNumber,
      notificationNumber = _ref$notificationNumb === void 0 ? false : _ref$notificationNumb,
      children = _ref.children,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var tabRef = /*#__PURE__*/(0, _react.createRef)();

  var _useContext = (0, _react.useContext)(_NavTabs.NavTabsContext),
      iconPosition = _useContext.iconPosition,
      tabIndex = _useContext.tabIndex,
      hasIcons = _useContext.hasIcons,
      focusedLabel = _useContext.focusedLabel;

  (0, _react.useLayoutEffect)(function () {
    var _tabRef$current;

    focusedLabel === children.toString() && (tabRef === null || tabRef === void 0 ? void 0 : (_tabRef$current = tabRef.current) === null || _tabRef$current === void 0 ? void 0 : _tabRef$current.focus());
  }, [focusedLabel]);

  var handleOnKeyDown = function handleOnKeyDown(event) {
    var _tabRef$current2;

    switch (event.key) {
      case " ":
      case "Enter":
        tabRef === null || tabRef === void 0 ? void 0 : (_tabRef$current2 = tabRef.current) === null || _tabRef$current2 === void 0 ? void 0 : _tabRef$current2.click();
        event.preventDefault();
        break;
    }
  };

  return /*#__PURE__*/_react["default"].createElement(TabContainer, {
    active: active,
    role: "tab",
    "aria-selected": active
  }, /*#__PURE__*/_react["default"].createElement(Tab, (0, _extends2["default"])({
    href: !disabled && href ? href : undefined,
    disabled: disabled,
    iconPosition: iconPosition,
    hasIcon: hasIcons,
    ref: function ref(anchorRef) {
      tabRef.current = anchorRef;

      if (_ref2) {
        if (typeof _ref2 === "function") _ref2(anchorRef);else {
          _ref2.current = anchorRef;
        }
      }
    },
    onKeyDown: handleOnKeyDown,
    tabIndex: active ? tabIndex : -1
  }, otherProps), icon && /*#__PURE__*/_react["default"].createElement(TabIconContainer, {
    iconPosition: iconPosition
  }, typeof icon === "string" ? /*#__PURE__*/_react["default"].createElement(TabIcon, {
    src: icon
  }) : icon), /*#__PURE__*/_react["default"].createElement(LabelContainer, null, children, notificationNumber && /*#__PURE__*/_react["default"].createElement(BadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_Badge["default"], {
    notificationText: notificationNumber > 99 ? "+99" : notificationNumber,
    disabled: disabled
  })))));
});

var TabContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  border-bottom: 2px solid ", ";\n"])), function (props) {
  return props.active ? "#6f2c91" : "#0000001a";
});

var Tab = _styledComponents["default"].a(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: ", ";\n  justify-content: center;\n  align-items: center;\n\n  font-family: \"Open Sans\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 1rem;\n  color: ", ";\n  text-decoration-color: transparent;\n  cursor: ", ";\n\n  height: ", ";\n  min-width: 164px;\n  margin: 0.5rem;\n  padding: 0.375rem;\n\n  border-radius: 4px;\n\n  ", "\n"])), function (props) {
  return props.hasIcon && props.iconPosition === "top" ? "column" : "row";
}, function (props) {
  return props.disabled ? "#0000004D" : "#333333";
}, function (props) {
  return props.disabled ? "not-allowed" : "pointer";
}, function (props) {
  return props.hasIcon && props.iconPosition === "top" ? "66px" : "32px";
}, function (props) {
  return !props.disabled && ":hover {\n    background: #0000000D;\n  }\n\n  :focus {\n    outline: 2px solid #33aaff};\n  }\n\n  :active {\n    background: #0000001A;\n    outline: 2px solid #33aaff};\n  }";
});

var TabIcon = _styledComponents["default"].img(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])([""])));

var TabIconContainer = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: 24px;\n  max-width: 24px;\n  margin-bottom: ", ";\n  margin-right: ", ";\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  img,\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n"])), function (props) {
  return props.iconPosition === "top" && "0.375rem";
}, function (props) {
  return props.iconPosition === "left" && "0.625rem";
});

var LabelContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n"])));

var BadgeContainer = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 0.5rem;\n"])));

var _default = DxcTab;
exports["default"] = _default;